var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A8A19B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.498 15.077L11.421 10l5.077-5.077c.67-.669.67-1.753 0-2.421-.668-.67-1.752-.67-2.42 0L9 7.579 3.923 2.502c-.669-.67-1.753-.67-2.422 0-.668.668-.668 1.752 0 2.421L6.58 10l-5.077 5.077c-.67.669-.67 1.753 0 2.421.668.67 1.752.669 2.42 0L9 12.421l5.077 5.077c.669.67 1.753.67 2.422 0 .668-.668.668-1.752 0-2.421z",
    transform: "translate(-20 -30) translate(20 30)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemClose);
export default __webpack_public_path__ + "static/media/system-close.e5241c97.svg";
export { ForwardRef as ReactComponent };